/**
 * Video modals
 * ------------
 * Autoplay/stop for modal video iframes, plus Termly consent-gating for embeds.
 */

// Append autoplay with the correct separator; the embed URL may have no query string.
function withAutoplay(url) {
    if (url.indexOf('autoplay=1') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
}

// Only an absolute http(s) src is playable — skips Termly-blocked iframes (real URL in data-src).
function playableSrc(iframe) {
    var raw = (iframe && iframe.getAttribute) ? (iframe.getAttribute('src') || '') : '';
    return /^https?:\/\//i.test(raw) ? raw : '';
}

function stopIframe(iframe) {
    var raw = playableSrc(iframe);
    if (!raw) return; // blocked/placeholder iframe — leave it to Termly
    var newSrc = raw.replace(/[?&]autoplay=1/, '');
    iframe.src = '';
    setTimeout(function () {
        iframe.src = newSrc;
    }, 1000);
}

// Termly loads async in <head>; wait for its API before wiring up.
function whenTermly(cb) {
    if (window.Termly && typeof window.Termly.on === 'function') {
        cb();
    } else {
        setTimeout(function () { whenTermly(cb); }, 200);
    }
}

function hasConsent(category) {
    try {
        var state = (window.Termly && typeof window.Termly.getConsentState === 'function')
            ? window.Termly.getConsentState()
            : null;
        return !!(state && state[category]);
    } catch (e) {
        return false;
    }
}

function renderGate($gate) {
    var category = $gate.data('consent-category');
    var $target = $gate.parent(); // figure.iframe-video or .block-video--spotify

    if (hasConsent(category)) {
        if ($target.find('iframe').length) return; // already loaded

        var embedSrc = $gate.data('embed-src');
        var height = $gate.data('embed-height') || '100%';
        var allow = $gate.data('embed-allow') || 'autoplay';
        var loading = $gate.data('embed-loading');

        // Autoplay applies only in the modal; bake it in if the modal is already open.
        var inModal = $gate.closest('.video-modal').length > 0;
        var modalOpen = inModal && $gate.closest('.video-modal').hasClass('show');

        var $iframe = $('<iframe>', {
            src: modalOpen ? withAutoplay(embedSrc) : embedSrc,
            width: '100%',
            height: height,
            frameborder: '0',
            title: $gate.data('embed-title') || '',
        });
        $iframe.attr('allowfullscreen', '');
        $iframe.attr('allow', allow);
        if (loading) $iframe.attr('loading', loading);
        $iframe.attr('data-categories', category); // hint to Termly's autoBlock

        $target.append($iframe);
        $gate.hide();
    } else {
        // Consent absent or revoked — drop any injected iframe, show the notice.
        $target.find('iframe').remove();
        $gate.show();
    }
}

function renderAllGates() {
    $('[data-video-consent]').each(function () {
        renderGate($(this));
    });
}

// Open Termly's preference center when the visitor asks to enable cookies.
$(document).on('click', '.video-consent__btn', function () {
    if (typeof window.displayPreferenceModal === 'function') {
        window.displayPreferenceModal();
    }
});

if ($('[data-video-consent]').length) {
    whenTermly(function () {
        window.Termly.on('initialized', renderAllGates);
        window.Termly.on('consent', renderAllGates);
        renderAllGates();
    });
}

$('.video-modal').on('shown.bs.modal', function (e) {
    var iframe = $(this).find('iframe')[0];
    var raw = playableSrc(iframe);
    if (!raw) return; // no real embed yet (gate pending or Termly-blocked)

    iframe.src = withAutoplay(raw);
});

$('figure.iframe-video').each(function () {
    var iframe = $(this).find('iframe');
    if (!iframe.length) return; // gated embed: rely on CSS default aspect ratio
    var ratio = iframe.attr('height') / iframe.attr('width');
    $(this).css('padding-bottom', ratio * 100 + '%');
});

$('.video-modal').on('hide.bs.modal', function (e) {
    var iframe = $(this).find('iframe')[0];
    stopIframe(iframe);
});
